import { render, staticRenderFns } from "./ArtifactVersionList.vue?vue&type=template&id=5c8a14ea&scoped=true"
import script from "./ArtifactVersionList.vue?vue&type=script&lang=js"
export * from "./ArtifactVersionList.vue?vue&type=script&lang=js"
import style0 from "./ArtifactVersionList.vue?vue&type=style&index=0&id=5c8a14ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a14ea",
  null
  
)

export default component.exports